import { Controller } from "@hotwired/stimulus"

// Accessible disclosure dropdown for a nav item with children (Om Cirkler).
// Disclosure pattern (WCAG 2.1 AA): a real <button> with aria-expanded
// controls the submenu region; links inside are only reachable when open.
// Works the same on mobile (inline expand) and desktop (popup). Closes on
// Escape (focus returns to the trigger) and on a click outside the item.
export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  toggle() {
    this.expanded ? this.close() : this.open()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.closeOnOutside)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.closeOnOutside)
  }

  keydown(event) {
    if (event.key === "Escape" && this.expanded) {
      this.close()
      this.triggerTarget.focus()
    }
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  get expanded() {
    return this.triggerTarget.getAttribute("aria-expanded") === "true"
  }
}
